module.exports = __webpack_public_path__ + "img/download.b6d8b0ca.svg";